module.exports = __webpack_public_path__ + "img/experiences_C Grounds Crew 1.e13b21ad.jpg";